module.exports = __webpack_public_path__ + "img/yacht.d94c24c7.jpg";